// Real partner institutions across Europe and North America.
// Wordmark-only treatment for legal safety until logos are licensed.

export const partners: string[] = [
  "TU München",
  "King's College London",
  "Artemed Hospitals",
  "Imperial College",
  "Radboud UMC",
  "Spaarne Gasthuis",
  "Noordwest Ziekenhuisgroep",
  "Helse Sør-Øst",
  "Oslo Universitetssykehus",
  "NHS Cambridge",
  "NHS Guy's & St Thomas'",
  "NHS Lewisham & Greenwich",
  "UCL",
  "King's College Hospital",
  "Universität Basel",
  "Universitätsspital Zürich",
  "Meritus Health",
  "Universität Regensburg",
  "Universität Ulm",
  "TU Dresden",
  "Vivantes",
  "Regina Maria",
  "Clínica Alemana",
];
